import { RoleData } from "../types/Role";
import { Team } from "../types/Team";
import { TokenData } from "../types/TokenData";
import { Visibility } from "../types/Visibility";

/**
 * The default distribution of Townsfolk, Outsiders, and Minions in
 * various player counts of a BOTC game. 
 */
const ROLE_DISTRIBUTION: Array<[number, number, number]> = [
    // Dummy values -- counts this low are impossible.
    [0,0,0],
    [0,0,0],
    [0,0,0],
    [0,0,0],
    [0,0,0],
    // 5 - Teensyville
    [3,0,1],
    [3,1,1],
    // 7
    [5,0,1],
    [5,1,1],
    [5,2,1],
    // 10
    [7,0,2],
    [7,1,2],
    [7,2,2],
    // 13
    [9,0,3],
    [9,1,3],
    [9,2,3],
]

/**
 * Get the role distribution for a specific player count.
 * @param playerCount The number of players.
 * @returns The number of townsfolk, outsiders, and minions respectively expected.
 */
export function roleDistribution(playerCount: number) {
    return ROLE_DISTRIBUTION[playerCount];
}

/**
 * Get the actual number of each role type assigned on the grim. 
 * @param tokens A list of all tokens on the grim. 
 * @param roles The canonical data for all roles. 
 * @returns A map showing how many assigned tokens there are for each team.
 */
export function playerCounts(tokens: TokenData[], roles: RoleData): { [key in Team]: number } {
    const output: {[key in Team]: number} = {
        [Team.Townsfolk]: 0,
        [Team.Outsider]: 0,
        [Team.Minion]: 0,
        [Team.Demon]: 0,
        [Team.Traveller]: 0,
        [Team.Fabled]: 0,
        [Team.Loric]: 0
    };
    for (const token of tokens) {
        if (token.visibility !== Visibility.Assigned) continue;
        const role = roles[token.id];
        output[role.team]++;
    }
    return output;
}

export function isStorytellerToken(token: TokenData, roles: RoleData) {
    return [Team.Loric, Team.Fabled].includes(roles[token.id].team);
}
